export default __webpack_public_path__ + "static/media/online-skola-bg-mobile.071a5a6a.png";